import { render, staticRenderFns } from "./Denial.vue?vue&type=template&id=06ef7afe&"
import script from "./Denial.vue?vue&type=script&lang=js&"
export * from "./Denial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports